export default __webpack_public_path__ + "static/media/ladder.84ca27dd.png";